import _ from "lodash";
import TableReportHelper from "report/helper";

export default async function PSMApontamentoColetasLocalizacaoReport(
    visita,
    indicador,
    apontamento,
    showObservacao = true
) {
    const h = new TableReportHelper(apontamento);
    const content = [];

    // Tabela 1: Coletas - Tocos Atacados
    if (!_.isEmpty(apontamento.coletasTocAt)) {
        content.push(
            h.panel([
                h.row(h.title("COLETAS - TOCOS ATACADOS")),
            ])
        );

        let titleArColetasTocAt = []
        let tamArColetasTocAt = []

        titleArColetasTocAt.push(h.title("Sphenophorus"))
        titleArColetasTocAt.push(h.title("Hyponeuma"))
        titleArColetasTocAt.push(h.title("Migdolus"))
        titleArColetasTocAt.push(h.title("Cupins"))
        titleArColetasTocAt.push(h.title("Foto"))
        tamArColetasTocAt.push("*")
        tamArColetasTocAt.push("*")
        tamArColetasTocAt.push("*")
        tamArColetasTocAt.push("*")
        tamArColetasTocAt.push("auto")

        if (showObservacao) {
            titleArColetasTocAt.push(h.title("Observação"))
            tamArColetasTocAt.push("*")
        }

        const coletasTocAtContent = [
            h.row(...titleArColetasTocAt),
        ];

        for (const coleta of apontamento.coletasTocAt) {
            const r = h.helper(coleta);
            let valueArColetasTocAt = []

            valueArColetasTocAt.push(r.numberField("pragaSphenophorusTocAt"))
            valueArColetasTocAt.push(r.numberField("pragaHyponeumaTocAt"))
            valueArColetasTocAt.push(r.numberField("pragaMigdolusTocAt"))
            valueArColetasTocAt.push(r.numberField("pragaCupinsTocAt"))
            valueArColetasTocAt.push(r.imageField("image.base64", { fit: [130, 130] }))

            if (showObservacao) {
                valueArColetasTocAt.push(r.textField("observacao"))
            }

            coletasTocAtContent.push(h.row(...valueArColetasTocAt));
        }

        content.push(h.panel(coletasTocAtContent, { widths: tamArColetasTocAt }));
    }

    // Tabela 2: Coletas - Pragas Encontradas
    if (!_.isEmpty(apontamento.coletasPragEnc)) {
        content.push(
            h.panel([
                h.row(h.title("COLETAS - PRAGAS ENCONTRADAS")),
            ])
        );

        let titleArColetasPragEnc = []
        let tamArColetasPragEnc = []

        titleArColetasPragEnc.push(h.title("Sphenophorus"))
        titleArColetasPragEnc.push(h.title("Hyponeuma"))
        titleArColetasPragEnc.push(h.title("Migdolus"))
        titleArColetasPragEnc.push(h.title("Cupins"))
        titleArColetasPragEnc.push(h.title("Foto"))
        tamArColetasPragEnc.push("*")
        tamArColetasPragEnc.push("*")
        tamArColetasPragEnc.push("*")
        tamArColetasPragEnc.push("*")
        tamArColetasPragEnc.push("auto")

        if (showObservacao) {
            titleArColetasPragEnc.push(h.title("Observação"))
            tamArColetasPragEnc.push("*")
        }

        const coletasPragEncContent = [
            h.row(...titleArColetasPragEnc),
        ];

        for (const coleta of apontamento.coletasPragEnc) {
            const r = h.helper(coleta);
            let valueArColetasPragEnc = []

            valueArColetasPragEnc.push(r.numberField("pragaSphenophorusPragEnc"))
            valueArColetasPragEnc.push(r.numberField("pragaHyponeumaPragEnc"))
            valueArColetasPragEnc.push(r.numberField("pragaMigdolusPragEnc"))
            valueArColetasPragEnc.push(r.numberField("pragaCupinsPragEnc"))
            valueArColetasPragEnc.push(r.imageField("image.base64", { fit: [130, 130] }))

            if (showObservacao) {
                valueArColetasPragEnc.push(r.textField("observacao"))
            }

            coletasPragEncContent.push(h.row(...valueArColetasPragEnc));
        }

        content.push(h.panel(coletasPragEncContent, { widths: tamArColetasPragEnc }));
    }

    return content.length > 0 ? content : null;
}
